{
    "NAME": "Lizenzmanagementsprache",
    "LicenseManagement_Action_Refresh": "Lizenzstatus aktualisieren",
    "LicenseManagement_Action_Reload": "Lizenzen neu laden",
    "LicenseManagement_Reload_Confirm": "Lizenzdaten neu laden?",
    "LicenseManagement_Reload_Success": "Lizenzdaten neu geladen.",
    "LicenseManagement_Status_Title": "Aktueller Lizenzstatus",
    "LicenseManagement_Status_Empty": "Es liegen keine Lizenzstatusinformationen vor.",
    "LicenseManagement_Status_LimitedAccess": "Für den aktuellen Geltungsbereich ist nur der allgemeine Lizenzstatus verfügbar.",
    "LicenseManagement_Status_Entry": "Eintrag",
    "LicenseManagement_Status_Value": "Wert",
    "LicenseManagement_Status_Usage": "Verwendung",
    "LicenseManagement_Status_Status": "Status",
    "LicenseManagement_Profiles_Title": "Telefonie-Serverprofile",
    "LicenseManagement_Profiles_Empty": "Es sind keine Telefonieserverprofile verfügbar.",
    "LicenseManagement_Billing_Title": "Abrechnungsberichte",
    "LicenseManagement_Billing_Filters": "Filter",
    "LicenseManagement_Billing_Advanced": "Erweiterte Optionen",
    "LicenseManagement_Billing_Actions": "Aktionen",
    "LicenseManagement_Billing_OnlyBillable": "Nur kostenpflichtige Konfiguration",
    "LicenseManagement_Billing_SystemWideUsers": "Systemweite Benutzer einbeziehen",
    "LicenseManagement_Billing_BillingExcluded": "Konfigurationen einschließen, die von der Abrechnung ausgeschlossen sind",
    "LicenseManagement_Billing_Simulation": "Einschließen von Simulationstelefonsystemen",
    "LicenseManagement_Billing_Summary": "Rechnungsübersicht",
    "LicenseManagement_Billing_Cdr": "Abrechnungs-CDRs",
    "LicenseManagement_Billing_SummaryConfirm": "Den Abrechnungsübersichtsbericht erstellen?",
    "LicenseManagement_Billing_CdrConfirm": "Den Abrechnungs-CDR-Bericht erstellen?",
    "LicenseManagement_Diagnostic": "Diagnosebericht",
    "LicenseManagement_Diagnostic_Confirm": "Generieren Sie den Diagnoselizenzbericht?",
    "LicenseManagement_Filter_Cme": "CME",
    "LicenseManagement_Filter_TelSys": "Telefonieserver",
    "LicenseManagement_Filter_Partition": "Partition"
}